import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { CartModification } from '@spartacus/cart/base/root';
import { LoggerService, OccEndpointsService, tryNormalizeHttpError } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DpCartModificationList } from '@app/core/types/backend/dp-cart-modification-list.interface';
import { DpOrderEntry } from '@app/core/types/view/dp-order-entry.interface';
import { CartAdditionalFieldsDto } from '@app-shared/cart/types/cart-additional-fields-dto.type';

@Injectable({ providedIn: 'root' })
export class DpCartApiService {
  readonly #httpClient = inject(HttpClient);
  readonly #occEndpoints = inject(OccEndpointsService);
  readonly #logger = inject(LoggerService);

  saveAdditionalFields(cart: string, value: CartAdditionalFieldsDto): Observable<DpCartModificationList> {
    const url = this.#occEndpoints.buildUrl('dpCartFields', { urlParams: { cart } });
    return this.#httpClient.put<DpCartModificationList>(url, { ...value });
  }

  saveContractCode(cart: string, entry: number, contractCode: string): Observable<unknown> {
    const url = this.#occEndpoints.buildUrl('dpCartContractCode', { urlParams: { cart, entry } });
    return this.#httpClient.put(url, { contractCode }).pipe(catchError((error) => throwError(() => error.error)));
  }

  updateEntries(
    orderEntries: Partial<DpOrderEntry>[],
    userId: string,
    cartId: string
  ): Observable<DpCartModificationList> {
    const url = this.#occEndpoints.buildUrl('requestedDeliveryDate', {
      urlParams: { userId, cartId }
    });
    return this.#httpClient
      .put<DpCartModificationList>(url, { orderEntries })
      .pipe(catchError((error) => throwError(() => tryNormalizeHttpError(error, this.#logger))));
  }

  removeSelectedEntries(cartEntries: string, userId: string, cartId: string): Observable<CartModification[]> {
    const url = this.#occEndpoints.buildUrl('removeSelectedEntries', { urlParams: { userId, cartId, cartEntries } });
    return this.#httpClient
      .delete<CartModification[]>(url)
      .pipe(catchError((error) => throwError(() => tryNormalizeHttpError(error, this.#logger))));
  }
}
